import { HtsClassificationTopic, HtsTopicKind } from "../constants";
import { HtsClassificationTopicConfig } from "../schemas";

export const motivation: HtsClassificationTopicConfig = {
  id: HtsClassificationTopic.MOTIVATION,
  label: "Motivation",
  kind: HtsTopicKind.Readiness,
  narrativeFields: [
    "what the candidate has actually done to prepare (research, sessions attended, related work/volunteering)",
    "how long they've been actively preparing",
    "whether their preparation lines up with what they say they want",
  ],
  followUpTriggers: [
    "the answer names an intention (\"I want to\") with no concrete action taken",
    "\"a while\" or similarly vague duration is given for how long they've been preparing",
  ],
  hardBarrierFacts: [],
};
